module.exports = "https://web-assets.ifttt.com/packs/media/header/logo-ifttt-d954afe6.svg";